export const categoryItems = (category: string) => {
  for (let i = 0; i < ResidentialItems.length; ++i) {
    if (ResidentialItems[i].category == category) {
      return ResidentialItems[i].items
    }
  }
}

export const getVolume = (category: string, itemName: string): number => {
  for (let i = 0; i < ResidentialItems.length; ++i) {
    if (ResidentialItems[i].category == category) {
      for (let j = 0; j < ResidentialItems[i].items.length; ++j) {
        if (ResidentialItems[i].items[j].item == itemName) {
          return ResidentialItems[i].items[j].volumeStd
        }
      }
    }
  }
}

export const ResidentialItemCategories: Array<string> = [
  'Appliances',
  'Bedroom',
  'Dining Room',
  'Exercise Equipment',
  'Garage',
  'Kitchen',
  'Living Room',
  'Miscellaneous',
  'Nursery',
  'Office',
  'Outdoor'
]

const ResidentialItems = [
  {
    category: 'Appliances',
    items: [
      {
        item: 'Air Conditioner, Window',
        volumeStd: 20
      },
      {
        item: 'Dehumidifier',
        volumeStd: 10
      },
      {
        item: 'Dishwasher',
        volumeStd: 20
      }
    ]
  },
  {
    category: 'Bedroom',
    items: [
      {
        item: 'Bed, Single / Twin',
        volumeStd: 40
      },
      {
        item: 'Bed, Double / Full',
        volumeStd: 60
      },
      {
        item: 'Bed, Queen',
        volumeStd: 65
      },
      {
        item: 'Bed, King',
        volumeStd: 70
      }
    ]
  },
  {
    category: 'Dining Room',
    items: [
      {
        item: 'Bench, Harvest',
        volumeStd: 10
      },
      {
        item: 'Buffet, Base',
        volumeStd: 20
      },
      {
        item: 'Buffet, Hutch',
        volumeStd: 30
      }
    ]
  },
  {
    category: 'Exercise Equipment',
    items: [
      {
        item: 'Bicycle',
        volumeStd: 7
      },
      {
        item: 'Camp Stove, Portable',
        volumeStd: 8
      },
      {
        item: 'Cooler, Small',
        volumeStd: 3
      }
    ]
  },
  {
    category: 'Garage',
    items: [
      {
        item: 'Car',
        volumeStd: null
      }
    ]
  },
  {
    category: 'Kitchen',
    items: [
      {
        item: 'Cabinet',
        volumeStd: 30
      },
      {
        item: 'Chair, High',
        volumeStd: 5
      },
      {
        item: 'Chair, Kitchen',
        volumeStd: 5
      }
    ]
  },
  {
    category: 'Living Room',
    items: [
      {
        item: 'Bar, Portable',
        volumeStd: 15
      },
      {
        item: 'Bench, Piano',
        volumeStd: 5
      },
      {
        item: 'Bookcase',
        volumeStd: 20
      }
    ]
  },
  {
    category: 'Miscellaneous',
    items: [

    ]
  },
  {
    category: 'Nursery',
    items: [

    ]
  },
  {
    category: 'Office',
    items: [

    ]
  },
  {
    category: 'Outdoor',
    items: [

    ]
  }
]

export default ResidentialItems
